import React from "react";
import { Button, Icon } from "antd";
import style from "./style.module.scss";

interface AddBtnProps {
    onClick: () => void;
}

export default function AddBtn({ onClick }: AddBtnProps) {
    return (
        <Button type="default" block className={style.root} onClick={onClick}>
            <Icon type="plus" className={style.icon} /> 新增考核
        </Button>
    );
}
